import React from 'react';
const CustomResources = () => <></>;
export default CustomResources;
